import '../styles/AboutUs.css';
import founderPhoto from '../images/AboutUs/CEO.png';

const content = {
  swe: {
    heroTitle: 'Om oss',
    heroSubtitle:
      'Vi bygger långsiktiga relationer mellan företag och specialister inom IT, teknik och ekonomi.',
    heroPrimary: 'Kontakta oss',
    heroSecondary: 'Se våra tjänster',
    overviewTitle: 'Vi skapar affärsdrivna team',
    overviewParagraphs: [
      'Execora är ett rekryterings- och bemanningsföretag som hjälper organisationer att växa med rätt kompetens.',
      'Vi matchar erfarenhet, kultur och affärsbehov för långsiktiga samarbeten.',
      'Kvalitet, förtroende och precision är kärnan i vårt arbete.'
    ],
    values: [
      { title: 'Personlig matchning', desc: 'Vi lär känna behovet och skapar träffsäkra relationer.' },
      { title: 'Kvalitet över kvantitet', desc: 'Vi levererar noggrant utvalda och erfarna specialister.' },
      { title: 'Transparens och förtroende', desc: 'Ärlighet och tydlighet genom hela processen.' },
      { title: 'Långsiktiga partnerskap', desc: 'Vi bygger relationer som växer över tid.' }
    ],
    services: [
      { title: 'Rekrytering', desc: 'Effektiv process för roller där ni anställer direkt.' },
      { title: 'Bemanning', desc: 'Förstärkning inom teknik, ingenjörskap, IT och ekonomi.' },
      { title: 'Interimlösningar', desc: 'Snabb tillgänglighet i förändrings- och tillväxtfaser.' },
      { title: 'Kompetensområden', desc: 'Ingenjörer, ekonomer, IT och fler specialistprofiler.' }
    ],
    founderTitle: 'Grundare och ansvarig rekrytering',
    founderBio:
      'Mohammad Najib arbetar nära både företag och kandidater för att skapa hållbara och långsiktiga matchningar med fokus på professionalism, förtroende och tydlig kundförståelse.',
    founderQuote:
      'Rätt kompetens handlar inte bara om erfarenhet, utan om att hitta rätt person för rätt sammanhang.',
    chooseTitle: 'Varför välja oss?',
    choosePoints: [
      'Personlig matchning',
      'Branschförståelse',
      'Snabb och flexibel process',
      'Långsiktiga relationer'
    ],
    ctaTitle: 'Letar ni efter rätt kompetens?',
    ctaText: 'Vi hjälper er att hitta specialister som skapar resultat.',
    ctaButton: 'Kontakta oss'
  },
  eng: {
    heroTitle: 'About Us',
    heroSubtitle:
      'We build long-term relationships between companies and specialists in IT, technology and finance.',
    heroPrimary: 'Contact Us',
    heroSecondary: 'Explore Our Services',
    overviewTitle: 'We build business-focused teams',
    overviewParagraphs: [
      'Execora is a recruitment and staffing firm that helps organizations grow with the right talent.',
      'We match experience, culture and business needs to create sustainable partnerships.',
      'Quality, trust and precision are at the core of what we do.'
    ],
    values: [
      { title: 'Personal Matching', desc: 'We learn your needs and create accurate matches.' },
      { title: 'Quality over Quantity', desc: 'We deliver carefully selected, experienced specialists.' },
      { title: 'Transparency and Trust', desc: 'Honesty and clarity throughout the process.' },
      { title: 'Long-Term Partnerships', desc: 'We build relationships that grow over time.' }
    ],
    services: [
      { title: 'Recruitment', desc: 'Efficient process for direct-hire roles.' },
      { title: 'Staffing', desc: 'Extra capacity in technology, engineering, IT and finance.' },
      { title: 'Interim Solutions', desc: 'Rapid availability during transformation and growth.' },
      { title: 'Areas of Expertise', desc: 'Engineers, finance professionals, IT and more.' }
    ],
    founderTitle: 'Founder and recruitment lead',
    founderBio:
      'Mohammad Najib works closely with companies and candidates to create strong, long-term matches with focus on professionalism, trust, and understanding client needs.',
    founderQuote:
      'The right competence is not only about experience, but about finding the right person for the right context.',
    chooseTitle: 'Why choose us?',
    choosePoints: [
      'Personal matching',
      'Industry understanding',
      'Fast and flexible process',
      'Long-term relationships'
    ],
    ctaTitle: 'Looking for the right competence?',
    ctaText: 'We help you find specialists who create results.',
    ctaButton: 'Contact Us'
  }
};

function AboutUs({ lang = 'swe', navigateTo }) {
  const copy = content[lang] || content.swe;

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero-content">
          <p className="about-highlight">{lang === 'swe' ? 'Rekrytering • Bemanning • Interim' : 'Recruitment • Staffing • Interim'}</p>
          <h1>{copy.heroTitle}</h1>
          <p>{copy.heroSubtitle}</p>
          <div className="about-hero-actions">
            <button className="primary-btn" type="button" onClick={() => navigateTo?.('contact')}>
              {copy.heroPrimary}
            </button>
            <button className="secondary-btn" type="button" onClick={() => navigateTo?.('#services')}>
              {copy.heroSecondary}
            </button>
          </div>
        </div>
      </section>

      <section className="about-overview">
        <div>
          <h2>{copy.overviewTitle}</h2>
          {copy.overviewParagraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </section>

      <section className="about-values">

        <div className="section-top">
          <h3>{lang === 'swe' ? 'Våra värderingar' : 'Our Values'}</h3>
        </div>
        <div className="values-grid">
          {copy.values.map((value) => (
            <article key={value.title} className="value-card">
              <div className="value-top">
                <h4 className="value-title">{value.title}</h4>
              </div>
              <p>{value.desc}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="founder-section">
        <div className="founder-image-wrap">
          <img src={founderPhoto} alt="Mohammad Najib" className="founder-image round" />
        </div>
        <div className="founder-content">
          <p className="founder-role">{copy.founderTitle}</p>
          <h3>Mohammad Najib</h3>
          <p>{copy.founderBio}</p>
          <blockquote>“{copy.founderQuote}”</blockquote>
        </div>
      </section>

      <section className="about-why">
        <h3>{copy.chooseTitle}</h3>
        <div className="why-grid">
          {copy.choosePoints.map((point) => (
            <div key={point} className="why-card">
              <span>✓</span>
              <p>{point}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="about-cta">
        <div>
          <h3>{copy.ctaTitle}</h3>
          <p>{copy.ctaText}</p>
        </div>
        <button className="primary-btn" type="button" onClick={() => navigateTo?.('contact')}>
          {copy.ctaButton}
        </button>
      </section>
    </div>
  );
}

export default AboutUs;
